import { Guid, EMPTY_GUID } from "../types/Guid";
export namespace Cnt.ThreeDeeCrate.SDK {
export enum SubscriptionType { 
	NotSubscribed = 0,
	PremiumModelSubscription = 1,
}


/**
 * Represents an Auto-generated model for AuthResponse.
 */
export interface IAuthResponse { 
    Token?: string | undefined;
    User: UserDTO | undefined;
}

export class AuthResponse implements IAuthResponse { 
    public Token: string | undefined;
    public User: UserDTO | undefined;

    constructor(init: Partial<IAuthResponse>) { 
        this.Token = init.Token;
        this.User = init.User;
    }
}

/**
 * Represents an Auto-generated model for CreateStripeIdDTO.
 */
export interface ICreateStripeIdDTO { 
    Price: number | undefined;
    Name?: string | undefined;
    Description?: string | undefined;
}

export class CreateStripeIdDTO implements ICreateStripeIdDTO { 
    public Price: number | undefined;
    public Name: string | undefined;
    public Description: string | undefined;

    constructor(init: Partial<ICreateStripeIdDTO>) { 
        this.Price = init.Price;
        this.Name = init.Name;
        this.Description = init.Description;
    }
}

/**
 * Represents an Auto-generated model for PurchaseUrlRequestDTO.
 */
export interface IPurchaseUrlRequestDTO { 
    Url?: string | undefined;
    ContainerId: Guid | undefined;
    PriceId?: string | undefined;
}

export class PurchaseUrlRequestDTO implements IPurchaseUrlRequestDTO { 
    public Url: string | undefined;
    public ContainerId: Guid | undefined;
    public PriceId: string | undefined;

    constructor(init: Partial<IPurchaseUrlRequestDTO>) { 
        this.Url = init.Url;
        this.ContainerId = init.ContainerId;
        this.PriceId = init.PriceId;
    }
}

/**
 * Represents an Auto-generated model for ResultUrlDTO.
 */
export interface IResultUrlDTO { 
    Url?: string | undefined;
}

export class ResultUrlDTO implements IResultUrlDTO { 
    public Url: string | undefined;

    constructor(init: Partial<IResultUrlDTO>) { 
        this.Url = init.Url;
    }
}

/**
 * Represents an Auto-generated model for StripePriceIdDTO.
 */
export interface IStripePriceIdDTO { 
    StripePriceId?: string | undefined;
}

export class StripePriceIdDTO implements IStripePriceIdDTO { 
    public StripePriceId: string | undefined;

    constructor(init: Partial<IStripePriceIdDTO>) { 
        this.StripePriceId = init.StripePriceId;
    }
}

/**
 * Represents an Auto-generated model for SubscriptionDTO.
 */
export interface ISubscriptionDTO { 
    SubscriptionId?: string | undefined;
    PriceId?: string | undefined;
    IsSubscribed: boolean | undefined;
}

export class SubscriptionDTO implements ISubscriptionDTO { 
    public SubscriptionId: string | undefined;
    public PriceId: string | undefined;
    public IsSubscribed: boolean | undefined;

    constructor(init: Partial<ISubscriptionDTO>) { 
        this.SubscriptionId = init.SubscriptionId;
        this.PriceId = init.PriceId;
        this.IsSubscribed = init.IsSubscribed;
    }
}

/**
 * Represents an Auto-generated model for TokenRequest.
 */
export interface ITokenRequest { 
    Token?: string | undefined;
}

export class TokenRequest implements ITokenRequest { 
    public Token: string | undefined;

    constructor(init: Partial<ITokenRequest>) { 
        this.Token = init.Token;
    }
}

/**
 * Represents an Auto-generated model for UserDTO.
 */
export interface IUserDTO { 
    Id: Guid | undefined;
    Name?: string | undefined;
    Email?: string | undefined;
    ProfilePicture?: string | undefined;
    IsAdmin: boolean | undefined;
    Subscription: SubscriptionType | undefined;
}

export class UserDTO implements IUserDTO { 
    public Id: Guid | undefined;
    public Name: string | undefined;
    public Email: string | undefined;
    public ProfilePicture: string | undefined;
    public IsAdmin: boolean | undefined;
    public Subscription: SubscriptionType | undefined;

    constructor(init: Partial<IUserDTO>) { 
        this.Id = init.Id;
        this.Name = init.Name;
        this.Email = init.Email;
        this.ProfilePicture = init.ProfilePicture;
        this.IsAdmin = init.IsAdmin;
        this.Subscription = init.Subscription;
    }
}

 /**
 * Auto-generated client for the Auth controller.
 */
export class Auth {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async ValidateUserSubscription( ): Promise<AuthResponse> {
        const url = `${this.baseUrl}/api/Auth/ValidateUserSubscription`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async ValidateGoogleLogin(tokenRequest: TokenRequest ): Promise<AuthResponse> {
        const url = `${this.baseUrl}/api/Auth/ValidateGoogleLogin`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(tokenRequest) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
}

 /**
 * Auto-generated client for the Subscription controller.
 */
export class Subscription {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async CreateStripeId(createStripeIdDTO: CreateStripeIdDTO ): Promise<StripePriceIdDTO> {
        const url = `${this.baseUrl}/api/Subscription/CreateStripeId`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(createStripeIdDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetPurchaseUrl(purchaseUrlRequestDTO: PurchaseUrlRequestDTO ): Promise<ResultUrlDTO> {
        const url = `${this.baseUrl}/api/Subscription/GetPurchaseUrl`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(purchaseUrlRequestDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetSubscribeUrl(resultUrlDTO: ResultUrlDTO ): Promise<ResultUrlDTO> {
        const url = `${this.baseUrl}/api/Subscription/GetSubscribeUrl`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(resultUrlDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async CheckIsSubscribed( ): Promise<SubscriptionDTO> {
        const url = `${this.baseUrl}/api/Subscription/CheckIsSubscribed`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async CancelSubscription( ): Promise<SubscriptionDTO> {
        const url = `${this.baseUrl}/api/Subscription/CancelSubscription`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
}

 /**
 * Auto-generated API client.
 */
export class Api {

    public auth: Auth;
    public subscription: Subscription;

    constructor(baseUrl: string) { 
        this.auth = new Auth(baseUrl);
        this.subscription = new Subscription(baseUrl);
    }
}


}
